var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pangu-input-number-for-percent"},[_c('panguInputNumber',{attrs:{"disabled":_vm.disabled,"max":100,"min":_vm.min,"formatter":_vm.formatterFn,"parser":(value) => value.replace('%', '')},on:{"on-blur":_vm.onBlur,"on-change":_vm.onChange},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }